(() => {
  'use strict';
  const dialog = document.querySelector('[data-orso-help-dialog]');
  if (!dialog) return;
  const views = [...dialog.querySelectorAll('[data-orso-help-view]')];
  const closeButton = dialog.querySelector('[data-orso-help-close]');
  let opener = null;
  let backdropDown = false;
  const close = () => {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-orso-help]');
    if (!trigger) return;
    const view = views.find((item) => item.dataset.orsoHelpView === trigger.dataset.orsoHelp);
    if (!view) return;
    event.preventDefault();
    const menu = trigger.closest('details');
    opener = menu?.querySelector('summary') || trigger;
    views.forEach((item) => { item.hidden = item !== view; });
    menu?.removeAttribute('open');
    if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
    else dialog.setAttribute('open', '');
    closeButton?.focus({ preventScroll: true });
  });
  closeButton?.addEventListener('click', close);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  const outside = (event) => { const r = dialog.getBoundingClientRect(); return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom; };
  dialog.addEventListener('pointerdown', (event) => { backdropDown = event.target === dialog && outside(event); });
  dialog.addEventListener('click', (event) => { if (event.target === dialog && backdropDown && outside(event)) close(); backdropDown = false; });
  document.addEventListener('click', (event) => { if (event.target.closest?.('.orso-store-mobile-menu a')) document.querySelector('.orso-store-mobile-menu')?.removeAttribute('open'); });
})();
